
namespace GeniuzPOS.Member {

    @Serenity.Decorators.registerClass()
    export class PsMemberGenderDialog extends Serenity.EntityDialog<PsMemberGenderRow, any> {
        protected getFormKey() { return PsMemberGenderForm.formKey; }
        protected getIdProperty() { return PsMemberGenderRow.idProperty; }
        protected getLocalTextPrefix() { return PsMemberGenderRow.localTextPrefix; }
        protected getNameProperty() { return PsMemberGenderRow.nameProperty; }
        protected getService() { return PsMemberGenderService.baseUrl; }
        protected getDeletePermission() { return PsMemberGenderRow.deletePermission; }
        protected getInsertPermission() { return PsMemberGenderRow.insertPermission; }
        protected getUpdatePermission() { return PsMemberGenderRow.updatePermission; }

        protected form = new PsMemberGenderForm(this.idPrefix);

    }
}